import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  Grid,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  IconButton,
  Typography,
} from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import TopButton from "../../Components/UI/TopButtons";
import Placeholder from "../../Components/UI/Placeholder";
import Confirmation from "../../Components/Modal/Confirmation";
import Slide from "@mui/material/Slide";

import { commonSliceActions } from "../../Store/Slices/CommonSlice";
import { joinByKeys } from "../../Js/Common";

import { getAssignmentData } from "./Services";
import { getAssignmentLearnersData, getTasksUuid } from "../Report/Services";

import { orderBy } from 'lodash';

const InsightAssignmentList = (props) => {
  //Hooks
  const styles = useStyles();
  const navigation = useNavigate();
  const dispatch = useDispatch();

  // Redux state
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
  const { paramsdata } = useSelector((state) => state.common);

  // State
  const [assignments, setAssignments] = useState([]);
  const [learnerData, setLearnerData] = useState(null);
  const [alertFlag, setAlertFlag] = useState(false);

  useEffect(() => {
    console.log("InsightAssignmentList paramsdata======>", paramsdata.learnerData);
    setLearnerData(paramsdata.learnerData)
  }, [paramsdata]);

  useEffect(() => {
    if (learnerData != null) {
      fetchAssignments();
    }
  }, [learnerData]);

  // Route redirect function
  const goTo = async (assignmentData) => {
    //console.log(assignmentData, "=====assignmentData====>",learnerData.uid);
    if (assignmentData.attempted == false) {
      setAlertFlag(true);
      return;
    }

    let totalAssetData = await fetchTaskData(assignmentData);
    let params = {
      uid: assignmentData.uid,
      learners: [learnerData.uid],
      site_uuid: assignmentData.site_uuid
    };
    let resLearnersData = await getAssignmentLearnersData(params);
    
    console.log("resLearnersData======>", resLearnersData);

    let resObj = {};
    resObj = resLearnersData.response[0];
    if (!resObj.hasOwnProperty('genericscore')) {
      resObj.genericscore = 0;
      resObj.attemptedassets = 0;
    }
    resObj.totalAssets = totalAssetData;
    resObj.percentage = (resObj.genericscore / totalAssetData * 100).toFixed(2);
    let newObj = { ...learnerData, ...resObj }

    console.log("newObj======>", newObj);
    dispatch(
      commonSliceActions.setParamsData({
        learnerData: newObj,
        reportData: assignmentData
      })
    );
    navigation(`/Report/LearnerAssetList`);
  };

  const fetchTaskData = async (assignmentData) => {
    let params = {
      query: {
        $select: ['data1', 'tasktype'],
        uid: assignmentData.tasks.tasks,
        site_uuid: assignmentData.site_uuid
      }
    };
    let resTaskData = await getTasksUuid(params);

    let totalAssets = 0;
    resTaskData.data.forEach(element => {
      let assets;
      let tasktype = element.tasktype;
      if (tasktype == 'assets' || tasktype == 'library') {
        assets = element.data1.exersices;
      } else {
        assets = element.data1.media;
      }
      totalAssets = totalAssets + assets.length;
    });
    return totalAssets;
  };


  // Fetch Assignment Data
  const fetchAssignments = async () => {
    let assignmentData = await getAssignmentData({
      "assignment_ids": learnerData.assignment_ids,
      "site_uuid": userInfo.site_uuid
    });
    console.log("fetchAssignments====>", assignmentData.data);

    assignmentData.data.map((resAssignment, index) => {
      let flag = false;
      if (learnerData.attempted_assignment_ids) {
        flag = learnerData.attempted_assignment_ids.includes(resAssignment.uid);
      }
      resAssignment.attempted = flag;
    });    
    let sortedData = orderBy(assignmentData.data, ['attempted'], ['desc'])
    // console.log("sortedData=====>", sortedData);

    assignmentData.data = sortedData;
    setAssignments(assignmentData.data);
  };

  return (
    <>
      <TopButton
        title={"Insight Assignment List"}
        secondaryText={(learnerData) ? `Learner Name: ${joinByKeys(learnerData.name, ['firstname', 'lastname'], ' ')}` : ''}

      />

      <Grid
        container
        spacing={2}
        className={styles.scrollBar}
        sx={{
          mt: 1,
          px: 5,
          height: "75vh",
          overflow: "auto",
          justifyContent: "flex-start",
          alignContent: "flex-start",
        }}
      >
        {assignments &&
          assignments.length > 0 &&
          assignments.map((assignmentData, index) => {
            return (
              <Slide
                direction="up"
                timeout={500}
                in={true}
                mountOnEnter
                unmountOnExit
              >
                <Grid
                  item
                  xs={6}
                  sx={{ padding: "0px", mt: 2 }}
                  key={`${"eval_" + index}`}
                >
                  <List sx={{ padding: "0px", margin: "0px !important" }}>
                    <ListItem
                      disablePadding
                      sx={{
                        borderRadius: 2,
                        padding: 0,
                        backgroundColor: "#F5F7FF",
                      }}
                      onClick={() => {
                        goTo(assignmentData);
                      }}
                      secondaryAction={
                        <>
                          <IconButton
                            edge="end"
                            au6ria-label="comments"
                            sx={{
                              color: "primary.main",
                              backgroundColor: "#FFFFFF",
                            }}
                          >
                            <NavigateNextIcon
                              sx={{
                                fontSize: "1.2rem",
                                "@media (min-width: 1636px)": {
                                  fontSize: "2rem",
                                },
                              }}
                            />
                          </IconButton>
                        </>
                      }
                    // className={`${(selectedQType == assignmentData.uid) ? styles.activeText : ""}`}
                    >
                      <ListItemButton sx={{ borderRadius: 5 }} dense>
                        <ListItemText>
                          <Typography
                            sx={{
                              color: "primary.main",
                              fontSize: "1rem",
                              fontWeight: "600",
                              wordBreak: 'break-all',
                              "@media (min-width: 1636px)": {
                                fontSize: "1.4rem",
                              },
                            }}
                          >
                            {assignmentData.title}
                          </Typography>
                          <Typography
                            sx={{
                              color: "#A9A9A9",
                              fontSize: "0.75rem",
                              fontWeight: "600",
                              "@media (min-width: 1636px)": {
                                fontSize: "1.2rem",
                              },
                            }}
                          >
                            {assignmentData.attempted == true ? (
                              <>{"Attempted"}</>
                            ) : (
                              <>{"Not Attempted"}</>
                            )}
                          </Typography>
                        </ListItemText>
                      </ListItemButton>
                    </ListItem>
                  </List>
                </Grid>
              </Slide>
            );
          })}

        {!assignments ||
          (assignments.length == 0 && (
            <Placeholder
              primaryText="No assignment found"
              secondaryText="No assignment available for evaluation"
              image="assign"
            ></Placeholder>
          ))}
      </Grid>
      <Confirmation
        image="error"
        primaryText="Assignment not attempted!"
        visible={alertFlag}
        alert={true}
        timeout={2000}
        toggleModal={(flag) => setAlertFlag(flag)}
      />
    </>
  );
};
const useStyles = makeStyles({
  activeText: {
    backgroundColor: "#d7e2f2",
  },
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.6em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});

export default InsightAssignmentList;
